import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IRetailerLaunchWithFaire) {
    (function(Status) {
        Status["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
        Status["ELIGIBLE"] = "ELIGIBLE";
        Status["APPLIED"] = "APPLIED";
        Status["ACCEPTED"] = "ACCEPTED";
        Status["REJECTED"] = "REJECTED";
        Status["EXPIRED"] = "EXPIRED";
        Status["APPLICATION_IN_PROGRESS"] = "APPLICATION_IN_PROGRESS";
        Status["ON_HOLD"] = "ON_HOLD";
        Status["ON_HOLD_NO_LEASE"] = "ON_HOLD_NO_LEASE";
    })(IRetailerLaunchWithFaire.Status || (IRetailerLaunchWithFaire.Status = {}));
    (function(ApplicationType) {
        ApplicationType["APPLICATION_TYPE_UNKNOWN"] = "APPLICATION_TYPE_UNKNOWN";
        ApplicationType["SOFT_CREDIT_CHECK"] = "SOFT_CREDIT_CHECK";
        ApplicationType["PRE_QUALIFIED"] = "PRE_QUALIFIED";
        ApplicationType["IDV_CONFIRMED"] = "IDV_CONFIRMED";
        ApplicationType["OWF_AND_GRANTS"] = "OWF_AND_GRANTS";
    })(IRetailerLaunchWithFaire.ApplicationType || (IRetailerLaunchWithFaire.ApplicationType = {}));
    IRetailerLaunchWithFaire.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IRetailerLaunchWithFaire || (IRetailerLaunchWithFaire = {}));
export var IRetailerLaunchWithFaire;
